<ng-lottie [options]="options" (animationCreated)="onAnimate()">
</ng-lottie>
